<template>
<ValidationObserver ref="datos">
  <v-layout wrap>      
      <v-flex  >
        <ValidationProvider name="cuil/cuit/documento" rules="required" >
          <v-text-field v-model="perteneceACui" label="Cuit/Cuil/Documento" :disabled="!editMode" :loading="loading"
                        :append-icon="busquedaCuiEnabled ? 'search' : 'search-disabled'" @click:append="buscarPersonaPorCui({cui: perteneceACui,alertPersonaInexistente: alertPersonaInexistente, allowNuevo:allowNuevo})"
                        data-vv-name="cuil/cuit/documento" slot-scope="{errors,valid}" :error-messages="errors" :success="valid">
          </v-text-field>
        </ValidationProvider>
      </v-flex>

      <v-flex >
          <v-text-field v-model="perteneceANombre" label="Nombre" :disabled="!editMode" :loading="loading"
                        :append-icon="busquedaNombreEnabled ? 'search' : 'search-disabled'" @click:append="buscarPersonaPorNombre(perteneceANombre)">
          </v-text-field>
      </v-flex>

    <v-flex >
        <v-btn fab dark x-small color="purple" @click.stop="verLegajo()" v-if="perteneceAId !=null" >
          <v-icon>person</v-icon>
        </v-btn>
    </v-flex >

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
          <v-toolbar text dense :color="$store.state.UiColors.crudToolbarList">
            <v-icon>list</v-icon>
            <v-toolbar-title class="font-weight-light">Búsqueda de Personas</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-data-table 
            :headers="headers"
            :items="listaPersonas"
            
            :options.sync ="options"
            :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
            v-model="selectedRow"
            :loading="loading"
          >
            <template slot="no-data">
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron personas
              </v-alert>
            </template>
            <template slot="items" slot-scope="props">                        
                <tr>
                  <td class="text-xs-left">{{ props.item.nombreCompleto }}</td>
                  <td class="text-xs-left">{{ props.item.cui }}</td>

                  <td class="justify-center layout px-0">                
                  <v-icon @click="setSelection(props.item),dialog = false">check_circle_outline</v-icon></td>
                </tr>
            </template>
      </v-data-table>
      <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1"  @click="dialog = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card >
    </v-dialog>
    
    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000" v-if="tipoPersonaId == 1" >
        <legajo-persona :personaId="perteneceAId" > </legajo-persona>
    </v-dialog>

    <v-dialog v-model="showLegajoPersona" width="1000" v-if="tipoPersonaId == 2" >
        <legajo-persona-juridica :personaId="perteneceAId" > </legajo-persona-juridica>
    </v-dialog>

  </v-layout>
    </ValidationObserver>
</template>

<script>

import { ValidationObserver, ValidationProvider} from "vee-validate";
import LegajoPersona from '@/components/legajo/layout.vue'
import LegajoPersonaJuridica from '@/components/legajo/personaJuridicaLayout.vue'

import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    'legajo-persona': LegajoPersona,
    'legajo-persona-juridica': LegajoPersonaJuridica,
  },
  data: () => ({
   dialog:false,        
   options: { // definición de paginación
      sortDesc:[false],
      sortBy:[''],
      page: 1,
      itemsPerPage: 5,
      rowsPerPageItems:[5,10,20]
    }, 
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
      { text: 'Nombre', value: 'nombre' },
      { text: 'Cui', value: 'cui' }
    ],        
    records: [], // registros
    selectedRow: [],
    perteneceANombre:'',
    perteneceACui:'',
    perteneceAId:null,
    tipoPersonaId:1,
    showLegajoPersona: false
  }),
  props: {
    value: {
      type: Object,
      required: false
    },
    propName:{
        type: String,
        required: true,
        default: 'persona'
    },
    label: {
      type: String,
      default: 'Búsqueda Persona'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    allowNuevo: {
      type: Boolean,
      required: true,
      default: false
    }, 
    alertPersonaInexistente: {
      type: Boolean,
      required: true,
      default: true
    }, // Si es false, al no encontrase a la persona, no emite un aviso
    setPersona: Function
  },
  watch:{
    'value.perteneceACui': function(item){
        this.perteneceACui = item;
        console.log(item);
    },
    'value.perteneceANombre': function(item){
        this.perteneceANombre = item;
    },
    'value.perteneceAId': function(item){
        this.perteneceAId = item;
    },
    async personaBusqueda (value) {
       console.log('personaBusqueda') 
       console.log(value)

      if(value != null){
        this.perteneceACui = value.cui;
        this.perteneceANombre = value.nombreCompleto;

        if(this.allowNuevo && value.esNuevo){
          const res = await this.$dialog.confirm({
            text: 'No se encontró a una persona con los datos ingresados. ¿Quiere darlo de alta?',
            title: 'Alta de Personas ',
            persistent: true // Parece que no funciona...
          })

          if (!res) {
            return;
          }

           const res2 = await this.$dialog.confirm({
            text: '¿Es una persona Jurídica?',
            title: 'Alta de Personas ',
            persistent: true // Parece que no funciona...
          })

          if (res2) {
            this.tipoPersonaId =2;
            this.setSelection({tipoPersonaId: 2,  cui: this.perteneceACui, id: '00000000-0000-0000-0000-000000000000', nombreCompleto: value.nombreCompleto});
          }
          else{
            this.tipoPersonaId =1;
            this.setSelection({tipoPersonaId: 1, documento: this.perteneceACui.substring(2,10), cui: this.perteneceACui, id: '00000000-0000-0000-0000-000000000000', nombreCompleto: value.nombreCompleto});
          }

        }
      }      
    },
   
    listaPersonas (value) {
      if(value === null || value === undefined || value.length === 0) return;

      if(value.length === 1){
        this.setSelection(value[0]);
      } else {
        this.records = value;
        this.dialog = true;
      }
    }
  },
  computed: {  
     ...mapGetters(['personaBusqueda','listaPersonas','loading']),
     busquedaCuiEnabled: function () {
      return (this.editMode && this.perteneceACui !== '');
    },
    busquedaNombreEnabled: function () {
      return (this.editMode && this.perteneceANombre.length >= 4);
    }
  },
  created () {
        
  },
  methods: {
    ...mapMutations(['setPersonaBusqueda']),
    ...mapActions(['buscarPersonaPorNombre','buscarPersonaPorCui']),
     setSelection(value){
      if(this.setPersona)
        this.setPersona(value);

      this.setPersonaBusqueda(value);
    },
    async buscarPorNombre(value){
      await this.buscarPersonaPorNombre(value);
    },
    async verLegajo(){
        this.showLegajoPersona = true;
    },
  },
  
}

</script>